import { render, staticRenderFns } from "./Footer.component.vue?vue&type=template&id=70f2d39d&"
import script from "./Footer.component.vue?vue&type=script&lang=ts&"
export * from "./Footer.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports